// extracted by mini-css-extract-plugin
module.exports = {"wincalc-frames":"frames_wincalc-frames__1lKBm"};